// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import "./css/Card.scss"

export default function BasicCard({cardData}) {
    return(
        <div className="basiccard-body">
            <span className="counter">
                {cardData.count}
            </span>
        </div>  
    )
}